<form #passwordForm="ngForm">
  <div>パスワード: <input [(ngModel)]="password" (input)="onInputChange($event.target.value)" [ngModelOptions]="{standalone: true}" placeholder="パスワード" /></div>
  <button type="submit" (click)="submit()">入室</button>
</form>
<div>
  <span style="font-size: 12px;">{{help}}</span>
</div>